import { render, staticRenderFns } from "./FileMetadata.vue?vue&type=template&id=d7386bfe&scoped=true"
import script from "./FileMetadata.vue?vue&type=script&lang=ts"
export * from "./FileMetadata.vue?vue&type=script&lang=ts"
import style0 from "./FileMetadata.vue?vue&type=style&index=0&id=d7386bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7386bfe",
  null
  
)

export default component.exports